import { render } from "./IControl.vue?vue&type=template&id=b408e5e0"
import script from "./IControl.vue?vue&type=script&lang=js"
export * from "./IControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__